<template>
  <div>
    <el-tree
      ref="tree"
      :data="dataSource"
      highlight-current
      node-key="dfDefinitionCategoryCode"
      default-expand-all
      :expand-on-click-node="false"
      @node-click="clickNode"
      v-loading="loading"
    >
      <div slot-scope="{ node, data }" class="category-tree-node">
        <div style="margin-bottom: 2px;">{{ data.categoryOptionName }}</div>
        <div style="margin-top: 2px;">{{ data.categoryOptionNameEn }}</div>
      </div>
    </el-tree>
  </div>
</template>
<script>
export default {
  props: {
    dfDefinitionCode: { type: String, default: "" },
    disabled: { type: Boolean, default: false },
  },
  data() {
    return {
      dataSource: [],
      loading: false,
    };
  },
  methods: {
    async getCategoryTree() {
      this.loading = true;
      const res = await this.$api
        .dfDefinitionCategoryListApi({
          dfDefinitionCode: this.dfDefinitionCode,
          dfCategoryNo: "DF03",
        })
        .catch(() => null);
      this.loading = false;
      if (!res) return;

      this.dataSource = res?.body?.data || [];
    },
    clickNode(data) {
      this.$emit("chooseNode", data);
    },
    setDefaultNode({ dfDefinitionCategoryCode }) {
      this.$refs.tree.setCurrentKey(dfDefinitionCategoryCode);
    },
  },
  async mounted() {
    await this.getCategoryTree();
    if (this.dataSource?.length > 0) {
      this.$nextTick(() => {
        this.setDefaultNode(this.dataSource[0]);
        this.clickNode(this.dataSource[0]);
      });
    }
  },
};
</script>
<style lang="scss" scoped>
.category-tree-node {
  height: 64px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  font-size: 13px;
  font-weight: 400;
}
::v-deep .el-tree-node__content {
  height: auto !important;
}
::v-deep
  .el-tree--highlight-current
  .el-tree-node.is-current
  > .el-tree-node__content {
  background-color: #e6f7ff;
}
</style>
